import { COLORS } from 'helpers/globals'

export default {
  list: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 435,
    height: '100%',
    overflowY: 'auto',
    padding: 0
  },
  container: {
    padding: '.5rem'
  },
  title: {
    backgroundColor: COLORS.tertiary,
    fontSize: '1.6rem',
    textAlign: 'center',
    padding: '.5rem',
    borderBottom: `1px solid ${COLORS.quaternary}`
  },
  item: {
    paddingLeft: '.5rem',
    '& div': {
      color: 'lighten(#606c76, 20%)',
      lineHeight: '2rem'
    },
    '&:nth-of-type(even)': {
      background: COLORS.tertiary
    }
  },
  selected: {
    '& a': { color: '#4dc328' }
  },
  rightArrow: {
    fontSize: '2rem'
  },
  spacer: {
    paddingTop: '1rem'
  },
  lensWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '1.5rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/ProjectItemList/style.js